import React, { useState, useRef } from "react";
import csvIcon from "../assets/images/csv.png";
import { useTranslation } from "react-i18next";

const ImportPopup = (props) => {
  const { t } = useTranslation();
  const [file, setFile] = useState(null);
  const fileInputRef = useRef(null);
  const [checkedFields, setCheckedFields] = useState([]);
  const [checkedFieldsState, setCheckedFieldsState] = useState([]);

  const handleFileChange = (event) => {
    setFile(event.target.files[0]);
  };

  const xlFields = [
    { label: t("name_txt"), value: "Name" },
    { label: t("addrees1_txt"), value: "Address1" },
    { label: t("addrees2_txt"), value: "Address2" },
    { label: t("addrees3_txt"), value: "Address3" },
    { label: t("addrees4_txt"), value: "Address4" },
    { label: t("addrees5_txt"), value: "Address5" },
    { label: t("email_add_txt"), value: "EmailAddress" },
    { label: t("telephone_no_txt"), value: "TelephoneNumber" },
    { label: t("website_access_txt"), value: "WebsiteAccess" },
    { label: t("pricing_band_txt"), value: "PricingBand" },
    { label: t("accept_cwo_only_txt"), value: "AcceptCWOOnly" },
    { label: t("credit_limit_txt"), value: "CreditLimit" },
    { label: t("routedays_txt"), value: "RouteDays" },
    { label: t("account_objective1_txt"), value: "AccountObjective1" },
    { label: t("account_objective2_txt"), value: "AccountObjective2" },
    { label: t("sector_txt"), value: "Sectors" },
    { label: t("sub_depot_txt"), value: "SubDepot" },
    { label: t("intro_email_txt"), value: "IntroEmail" },
  ];

  const handleUpload = () => {
    if (file) {
      props.closePopup(null, true, file, props.impValue, checkedFields);
    } else {
      alert(t("please_select_file_before_uploading_txt"));
    }
  };

  const handleOnChangeFields = (position, e) => {
    const updatedCheckedState = checkedFieldsState.map((item, index) => {
      return index === position ? !item : item;
    });
    var updatedList = [...checkedFields];
    if (e.target.checked) {
      updatedList = [...checkedFields, e.target.value];
    } else {
      updatedList.splice(checkedFields.indexOf(e.target.value), 1);
      if (e.target.value === "EmailAddress") {
        updatedList = updatedList.filter((f) => f !== "IntroEmail");
        const introIndex = xlFields.findIndex((f) => f.value === "IntroEmail");
        if (introIndex > -1) updatedCheckedState[introIndex] = false;
      }
    }
    setCheckedFields(updatedList);
    setCheckedFieldsState(updatedCheckedState);
  };

  const triggerFileInput = () => {
    if (fileInputRef.current) {
      fileInputRef.current.click(); // Programmatically trigger the file input click event
    }
  };

  return (
    <div className="product-import-pop">
      <div className="product-import-pop-overlay"></div>
      <div className="product-import-wrap">
        <span
          className="close-import-pop"
          onClick={() => props.closePopup(null, false, null, null)}
        ></span>
        <div className="product-import-body">
          <div className="product-import-header">
            <h3>
              {t("import_txt")} {props.impValue} {t("by_csv_txt")}
            </h3>
          </div>
          <div className="product-import-content">
            {file && (
              <div className="file-added">
                <p>{t("added_file_txt")}</p>
              </div>
            )}
            {!file && (
              <div className="custom-file-add">
                <div className="custom-file" onClick={triggerFileInput}>
                  <span>{t("add_file_txt")}</span>
                  <input
                    type="file"
                    className="custom-file-input"
                    onChange={handleFileChange}
                    ref={fileInputRef}
                    accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                    style={{ display: "none" }}
                  />
                </div>
              </div>
            )}
            {file && (
              <div className="custom-file-choose">
                <p>
                  <span className="file-icon">
                    <img src={csvIcon} />
                  </span>
                  {file.name}
                </p>
                <button onClick={triggerFileInput}>
                  {t("replace_file_txt")}
                </button>
                <input
                  type="file"
                  className="custom-file-input"
                  onChange={handleFileChange}
                  ref={fileInputRef}
                  accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                  style={{ display: "none" }} // Hide the file input element
                />
              </div>
            )}
            <div className="input-field">
              <label>{t("customer_import_field_selection_note_txt")}</label>
              <br />
              <div>
                <a
                  onClick={() => {
                    const allChecked = xlFields.map(() => true);
                    setCheckedFieldsState(allChecked);
                    setCheckedFields(xlFields.map((field) => field.value));
                  }}
                >
                  {t("select_all_txt")}
                </a>{" "}
                |&nbsp;
                <a
                  onClick={() => {
                    const noneChecked = xlFields.map(() => false);
                    setCheckedFieldsState(noneChecked);
                    setCheckedFields([]);
                  }}
                >
                  {t("deselect_all_txt")}
                </a>
              </div>
              <br />
              {xlFields.map((field, index) => (
                <div
                  key={field.value}
                  className="check-box no-strike"
                  style={{ display: "inline-block", width: "200px" }}
                >
                  <input
                    type="checkbox"
                    name="FieldTobeExcluded"
                    id={`FieldTobeExcluded${index}`}
                    value={field.value}
                    checked={checkedFieldsState[index]}
                    disabled={
                      field.value === "IntroEmail" &&
                      !checkedFields.includes("EmailAddress")
                    }
                    onChange={(e) => handleOnChangeFields(index, e)}
                  />
                  <label
                    htmlFor={`FieldTobeExcluded${index}`}
                    className={field.value === "IntroEmail" ? "highlight" : ""}
                  >
                    {field.label}{" "}
                  </label>
                </div>
              ))}
            </div>
          </div>
          <div className="product-import-bottom">
            <button
              className="button cancel-btn"
              onClick={() => props.closePopup(null, false, null, null)}
            >
              {t("cancel_txt")}
            </button>
            <button
              className={`button upload-btn ${!file ? "disabled" : "active"}`}
              onClick={handleUpload}
              disabled={!file}
            >
              {t("upload_and_continue_txt")}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ImportPopup;
